
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/FastDelivery",
      function () {
        return require("private-next-pages/article/FastDelivery.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/FastDelivery"])
      });
    }
  